'use client'

import s from './main-hero.module.scss'
import cx from 'classnames'
import { BreadCrumbsV3 } from '../../atoms/breadcrumbs/breadcrumbs'
import { Crumb } from '../../atoms/breadcrumbs/breadcrumbs'
import { useClampToggle } from '@/hooks/use-clamp-toggle'
import { ClampButton } from '@/components/v3/atoms/clamp-button/clamp-button'

type Props = {
  title: string
  subTitle?: string
  description?: string
  breadcrumbs?: Crumb[]
  children?: React.ReactNode
}

export const MainHero = ({
  title,
  subTitle,
  description,
  breadcrumbs,
  children,
}: Props) => {
  const { ref: descRef, isClamped, isOpen, toggle } = useClampToggle()

  return (
    <div className={s.wrapper}>
      {breadcrumbs && (
        <BreadCrumbsV3 crumbs={breadcrumbs} className={s.breadcrumbs} />
      )}
      <div>
        <h1 className={s.header}>{title}</h1>
        {subTitle && <h2 className={s.subTitle}>{subTitle}</h2>}
      </div>
      {description && (
        <div className={s.descriptionContainer}>
          <p
            ref={descRef}
            className={cx(s.description, {
              [s.descriptionOpen]: isOpen,
            })}
          >
            {description}
          </p>
          {isClamped && <ClampButton isOpen={isOpen} onClick={toggle} />}
        </div>
      )}
      {children}
    </div>
  )
}
